/**
 * Defines the expected format for API keys.
 * Format: `sk_` followed by 64 lowercase hexadecimal characters.
 */
export const API_KEY_REGEX = /^sk_[0-9a-f]{64}$/;

/**
 * Validates if the provided string matches the expected API key format.
 *
 * @param key The API key string to validate.
 * @returns True if the key matches the format, false otherwise.
 */
export function isValidApiKeyFormat(key: string | null | undefined): key is string {
  return typeof key === "string" && API_KEY_REGEX.test(key);
}
